<template>
  <!-- 页面框架总体布局组件 -->
  <div>
    <!-- header start -->
    <ckx-header>header</ckx-header>
    <!-- header end -->
    <!-- 路由视图 start -->
    <transition name="fade">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view class="router">路由视图</router-view>
      </keep-alive>
      <!-- <router-view class="router">路由视图</router-view> -->
    </transition>
    <!-- 路由视图 end -->
    <!-- footer start -->
    <ckx-footer>footer</ckx-footer>
    <!-- footer end -->
  </div>
</template>

<script>
// import api from '@/api' // api
import header from '@/components/header' // header 组件
import footer from '@/components/footer' // footer 组件

export default {
  data () {
    return {

    }
  },
  components: {
    'ckx-header': header,
    'ckx-footer': footer
  },
  methods: {
    /**
     * body 去除mobile class类名，去除手机自适应
     **/
    clearBodyClass () {
      console.log('body 去除mobile class类名，去除手机自适应')
      var bodyArr = document.getElementsByTagName('body')
      bodyArr[0].classList.remove('mobile')
    }
  },
  created () {
    console.log('初始化框架')
    // body 去除mobile class类名，去除手机自适应
    // this.clearBodyClass()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue